import React from "react";
import { Linkedin, Mail, Phone, MessageCircle } from "lucide-react";
import { SECTION, FOOTER } from "@/constants/testIds";
import { useI18n } from "@/i18n/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  const f = t.footer;
  const links = [
    { id: "expertises", label: t.nav.expertises },
    { id: "references", label: t.nav.references },
    { id: "methode", label: t.nav.method },
    { id: "insights", label: t.nav.insights },
    { id: "about", label: t.nav.about },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <footer data-testid={SECTION.footer} className="bg-[#06101F] text-slate-300">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-cyan-tech text-navy font-display font-semibold">
              B
            </span>
            <span className="font-display text-white text-lg font-semibold">
              Birrou Advisory <span className="text-slate-400">{t.nav.brandSub}</span>
            </span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-md">
            Vision • Stratégie • Transformation • Exécution.
            <br />
            {f.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] uppercase tracking-[0.22em] text-cyan-tech font-semibold">
            {f.navHeading}
          </div>
          <ul className="mt-4 space-y-2">
            {links.map((l) => (
              <li key={l.id}>
                <a href={`#${l.id}`} className="text-sm hover:text-white transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] uppercase tracking-[0.22em] text-cyan-tech font-semibold">
            {f.contactHeading}
          </div>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a
                data-testid={FOOTER.email}
                href="mailto:diallobirrou@gmail.com"
                className="inline-flex items-center gap-2 hover:text-white"
              >
                <Mail className="h-4 w-4" /> diallobirrou@gmail.com
              </a>
            </li>
            <li>
              <a
                data-testid={FOOTER.phone}
                href="tel:+33672328408"
                className="inline-flex items-center gap-2 hover:text-white"
              >
                <Phone className="h-4 w-4" /> +33 6 72 32 84 08
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/33672328408"
                target="_blank"
                rel="noreferrer noopener"
                className="inline-flex items-center gap-2 hover:text-white"
              >
                <MessageCircle className="h-4 w-4" /> WhatsApp
              </a>
            </li>
            <li>
              <a
                data-testid={FOOTER.linkedin}
                href="https://linkedin.com/in/diallobirrou"
                target="_blank"
                rel="noreferrer noopener"
                className="inline-flex items-center gap-2 hover:text-white"
              >
                <Linkedin className="h-4 w-4" /> linkedin.com/in/diallobirrou
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="container-x py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>
            © {new Date().getFullYear()} Birrou Advisory {t.nav.brandSub}. {f.rights}
          </div>
          <div className="font-mono">Vision • Stratégie • Transformation • Exécution</div>
        </div>
      </div>
    </footer>
  );
}
